import React from "react";

const PreLoader = (props) => {
return (
    <section className="spinner-bg">
        <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </section>
)};

export default PreLoader;